/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */
import { If, Then } from "react-if";
import { Table, Tag } from "@nordcloud/gnui";
import { StyledTd } from "~/components/Tables/styles";
import { ROUTES } from "~/routing/routes";
import { SelectionMethod } from "~/types";
import { NameCell } from "~/views/resources/components/NameCell";
import { OSCell } from "~/views/resources/components/OSCell";
import { ResourceWithSelectionMethod } from "../../../types";

type Props = {
  resource: Partial<ResourceWithSelectionMethod>;
};

export function ResourceRow({ resource }: Props) {
  const os = {
    subType: resource?.os?.subType ?? "",
    type: resource?.os?.type ?? "",
  };

  return (
    <Table.tr>
      <StyledTd css={{ width: "2%" }}>
        <OSCell os={os} />
      </StyledTd>
      {/* Name occupies all available space */}
      <Table.td css={{ width: "100%" }}>
        <NameCell
          to={ROUTES.resources.generateDetails(resource?.id ?? "")}
          provider={resource?.provider}
        >
          {resource?.name}
        </NameCell>
      </Table.td>
      <Table.td>
        <If condition={resource.selectionMethod === SelectionMethod.manual}>
          <Then>
            <Tag
              text={SelectionMethod.manual}
              color="blue"
              aria-label="manual method"
            />
          </Then>
        </If>
        <If condition={resource.selectionMethod === SelectionMethod.dynamic}>
          <Then>
            <Tag
              text={SelectionMethod.dynamic}
              color="purple"
              aria-label="dynamic method"
            />
          </Then>
        </If>
      </Table.td>
    </Table.tr>
  );
}
